import React, { useContext, useEffect } from 'react';
import { Grid, openNotificationWithIcon, useAssetTranslation } from '@mss/mss-component-library';
import { notification } from 'antd';
import { AppContext, LicenseEntity, useConfigurationQuery } from 'jsx';
import moment from 'moment';
import StatusLine from './components/StatusLine';
import { statusConfigs } from './util';

const HomePage = () => {
  const { allLicenses } = useContext(AppContext);
  const { data: config } = useConfigurationQuery();
  const { t } = useAssetTranslation();

  useEffect(() => {
    if (!!allLicenses?.length) {
      const expiredLicenses = allLicenses.filter(
        (license: LicenseEntity) =>
          moment().diff(license.expires_at, 'days') > 0
      );

      const expiringLicenses = allLicenses.filter(
        (license: LicenseEntity) =>
          moment().diff(license.expires_at, 'days') < 0 &&
          moment().diff(license.expires_at, 'days') > -30
      );

      // Show expiring licenses only once, always show expired licenses
      const shownExpiringLicenses = localStorage.getItem('expiringLicenses');

      expiringLicenses.forEach((license: LicenseEntity) => {
        const shownNotification =
          shownExpiringLicenses &&
          JSON.parse(shownExpiringLicenses).find(
            (shownLicense: LicenseEntity) => license.id === shownLicense.id
          );

        if (!shownNotification) {
          openNotificationWithIcon(
            notification.info,
            t('License {{licenseName}} will expire soon.', {
              licenseName: license.name,
              ns:'configuration'
            }),
            t(
              'License {{licenseName}} will expire in {{days}} days.',
              {
                licenseName: license.name,
                days: Math.abs(moment().diff(license.expires_at, 'days')),
                ns:'configuration'
              }
            )
          );
        }
      });

      expiredLicenses.forEach((license: LicenseEntity) => {
        openNotificationWithIcon(
          notification.info,
          t('License {{licenseName}} has expired.', {
            licenseName: license.name,
            ns:'configuration'
          }),
          t(
            'License {{licenseName}} has expired {{daysAgo}} days ago.',
            {
              licenseName: license.name,
              daysAgo: Math.abs(moment().diff(license.expires_at, 'days')),
              ns:'configuration'
            }
          )
        );
      });

      localStorage.setItem(
        'expiringLicenses',
        JSON.stringify(expiringLicenses)
      );
    }
  }, [allLicenses, t]);

  return (
    <Grid.Container className="mt-4">
      {Object.entries(statusConfigs(config?.unidirectional)).map(
        ([key, props]) => (
          <StatusLine {...props} key={key} endpoint={key} />
        )
      )}
    </Grid.Container>
  );
};

export default HomePage;
